import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreTo?: string;
  moreText?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  icon = 'ri-fire-line',
  moreTo,
  moreText = '查看更多',
}: SectionHeadingProps) {
  return (
    <div className="mb-4 flex items-end justify-between gap-4 border-b border-background-200 pb-3">
      <div className="flex items-center gap-2">
        <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-100 text-primary-600">
          <i className={`${icon} text-base`}></i>
        </span>
        <h2 className="text-lg font-black tracking-tight text-foreground-950">{title}</h2>
        {subtitle && (
          <span className="hidden text-xs text-foreground-500 sm:inline">{subtitle}</span>
        )}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap text-xs font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          {moreText}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}